import { NodeTypeName, ExportType } from "../../domain/domain";

export const XML_AND_PROVISIONS_PRINTOUT_NODES: NodeTypeName[] = [
    NodeTypeName.TITLE,
    NodeTypeName.DIVISION,
    NodeTypeName.DIVISION_PART,
    NodeTypeName.ARTICLE,
    NodeTypeName.ARTICLE_PART,
    NodeTypeName.ARTICLE_SUBPART,
    NodeTypeName.SECTION,
    NodeTypeName.SUBSECTION,
    NodeTypeName.PARAGRAPH,
    NodeTypeName.SUBPARAGRAPH,
    NodeTypeName.SUB_SUBPARAGRAPH
];

export const CERTIFIED_COPY_NODES: NodeTypeName[] = [
    NodeTypeName.TITLE,
    NodeTypeName.DIVISION,
    NodeTypeName.DIVISION_PART,
    NodeTypeName.ARTICLE,
    NodeTypeName.ARTICLE_PART,
    NodeTypeName.ARTICLE_SUBPART,
    NodeTypeName.SECTION
];

export const SHOW_HEADING_NODES: NodeTypeName[] = [
    NodeTypeName.TITLE,
    NodeTypeName.DIVISION,
    NodeTypeName.DIVISION_PART,
    NodeTypeName.ARTICLE,
    NodeTypeName.ARTICLE_PART,
    NodeTypeName.ARTICLE_SUBPART
];

export const SECTION_AND_BELOW_NODES: NodeTypeName[] = [
    NodeTypeName.SECTION,
    NodeTypeName.SUBSECTION,
    NodeTypeName.PARAGRAPH,
    NodeTypeName.SUBPARAGRAPH,
    NodeTypeName.SUB_SUBPARAGRAPH
];

export const COMPONENT_SELECTION_PANEL_EXPORT_TYPES: ExportType[] = [
    ExportType.EXPORT_TO_XML,
    ExportType.CERTIFIED_COPY,
    ExportType.PROVISIONS_PRINTOUT,
    ExportType.HEADING_ONLY
];

export const DISABLED_UPDATES_PRINTOUT_CITATIONS: string[] = ['0.5', '00', '90'];

export const EXPORT_FILE_EXTENSIONS: Record<string, string> = {
    EXPORT_TO_XML: 'xml',
    default: 'docx'
};

export const EXPORT_FILENAME_PREFIXES: Record<string, string> = {
    EXPORT_TO_XML: 'export',
    ARTICLE_ANALYSIS: 'article_analysis',
    TITLE_ANALYSIS: 'title_analysis',
    CERTIFIED_COPY: 'certified_copy',
    UPDATES_PRINTOUT: 'updates_printout',
    PROVISIONS_PRINTOUT: 'provision_printout',
    HEADING_ONLY: 'heading_only',
    default: 'export'
};